// The Comic Machine - Comic UI

var ComicController = (function() {

  var config = {
    save: {
      type: {
        default: "application/octet-stream",
        json: "application/json",
        xml: "text/xml",
      },
    },
    debug: {
      tail: true,
      bounds: false,
      grid: false,
      intersects: false,
      hover: false,
    },
  };

  // Method to download dynamic files with a specified name
  function download(filename, data) {
    var trigger = document.createElement("a");
    trigger.setAttribute("href", data);
    trigger.setAttribute("download", filename);
    if (document.createEvent) {
      var event = document.createEvent("MouseEvents");
      event.initEvent("click", true, true);
      trigger.dispatchEvent(event);
    } else {
      trigger.click();
    }
  }

  // Handles UI and DOM manipulation
  var UI = {

    // DOM elements to manage
    elements: {},

    // Initialize the UI and DOM manager
    initialize: function() {

      // DOM elements to manage
      UI.elements = {
        create: document.querySelector(".create"),
        load: document.querySelector(".load"),
        logout: document.querySelector(".logout"),
        save: document.querySelector(".save"),
        back: document.querySelector(".back"),
        details: document.querySelector(".details"),
        cover: document.querySelector(".details-comic-cover"),
        title: document.querySelector(".details-comic-title"),
        series: document.querySelector(".details-comic-series"),
        author: document.querySelector(".details-comic-author"),
        passphrase: document.querySelector(".details-comic-passphrase"),
        publish: document.querySelector(".input-published"),
        embed: {
          button: document.querySelector(".button-embed"),
          container: document.querySelector(".embed"),
          width: document.querySelector(".embed-comic-width"),
        },
        thumbnail: document.querySelector(".thumbnail"),
        pages: document.querySelector(".panel-bottom"),
        add: document.querySelector(".add-page"),
        text: document.querySelector(".add-text"),
        preview: document.querySelector(".preview"),
        previewAuto: document.querySelector(".preview-auto"),
        previewPage: document.querySelector(".preview-page")
      };

      // Bind handlers to events
      UI.bindEvents();

    },

    // Bind handlers to events
    bindEvents: function() {

      // Handle on click of preview comic button
      attachHandler(UI.elements.preview, function() {
        var comic = Comic.current.exportJSON(null, true);
        VieweController.open(comic);
      });

      // Handle on click of preview comic button
      attachHandler(UI.elements.previewAuto, function() {
        var comic = Comic.current.exportJSON(null, true);
        comic.autoPlay = true;
        comic.autoLoop = true;
        VieweController.open(comic);
      });

      // Handle on click of preview page button
      attachHandler(UI.elements.previewPage, function() {
        var comic = Comic.current.exportJSON(Comic.current.pageIndex, true);
        VieweController.open(comic);
      });

      // Handle on click of create new comic button
      attachHandler(UI.elements.create, function(event) {
        var message = "Are you sure you would like to create a new comic?\n" +
          "Any unsaved changes will be lost."; // HACK
        if (!window.confirm(message)) return;
        // Create a new comic instance
        Comic.create();
      });

      // Handle on click of save comic
      attachHandler(UI.elements.save, function(event) {

        var comic = Comic.current;

        if (comic.pageList[0].thumbnail.url) {
          UI.elements.cover.src = comic.pageList[0].thumbnail.url;
        }
        if (comic.title) {
          UI.elements.title.value = comic.title;
        }
        if (comic.series) {
          UI.elements.series.value = comic.series;
        }
        if (comic.author) {
          UI.elements.author.value = comic.author;
        }
        if (comic.access) {
          UI.elements.passphrase.value = comic.access;
        }
        if (comic.published) {
          UI.elements.publish.checked = !!comic.published;
        }

        UI.elements.details.setAttribute("data-active", "true");

      });

      // Handle on click of embed comic
      attachHandler(UI.elements.embed.button, function(event) {
        var comic = Comic.current;
        if (!comic.published) {
          return window.alert("Please save and publish your comic first.");
        }
        UI.elements.embed.container.setAttribute("data-active", "true");
        UI.elements.embed.container.querySelector("textarea[name=comic-embed]").value = [
          '<iframe',
          ' src="https://', window.location.hostname, '/#/gallery/comic/', comic.uid, '?embed=true"',
          ' style="width:1024px;height:768px;border:0;">',
          '</iframe>',
        ].join("");
      });

      // Handle on click of save and continue
      var buttons = UI.elements.details.querySelectorAll(".form-button-save");
      attachHandler(buttons, function(event) {
        // Save the comic
        var data = Comic.current.exportJSON();
        // Update comic meta
        if (UI.elements.publish) {
          Comic.current.published = UI.elements.publish.checked;
          data.published = UI.elements.publish.checked;
        }
        if (UI.elements.title.value) {
          Comic.current.title = UI.elements.title.value;
          data.title = UI.elements.title.value;
        }
        if (UI.elements.series.value) {
          Comic.current.series = UI.elements.series.value;
          data.series = UI.elements.series.value;
        }
        if (UI.elements.author.value) {
          Comic.current.author = UI.elements.author.value;
          data.author = UI.elements.author.value;
        }
        if (UI.elements.passphrase.value) {
          data.access = window.btoa(UI.elements.passphrase.value);
        } else {
          data.access = "";
        }
        Comic.current.access = UI.elements.passphrase.value;
        API.comics.update(data, function(success, response) {
          console.log("save", success, response);
          if (success) {
            UI.elements.details.setAttribute("data-active", "false");
            // window.alert("Comic was saved.");
          } else {
            window.alert("An error occurred, please try again."); // HACK
          }
        });
      });

      // Handle on click of save and continue
      attachHandler(UI.elements.details.querySelector(".close"), function(event) {
        UI.elements.details.setAttribute("data-active", "false");
      });

      // Handle on click of embed
      attachHandler(UI.elements.embed.container.querySelectorAll(".close, .button-close"), function(event) {
        UI.elements.embed.container.setAttribute("data-active", "false");
      });

      // Handle on click of back button
      attachHandler(UI.elements.back, function(event) {
         // HACK: Move strings to config
        var message = [
          "Are you sure you would like to close this comic? ",
          "Any unsaved changes will be lost.",
        ].join("\n");
        if (!window.confirm(message)) {
          return;
        }
        // Route to the creator page
        window.location.href = "/#/creator";
        window.location.reload();
      });

      var teasePages = function() {
        UI.elements.pages.setAttribute("data-active", "true");
        window.setTimeout(function() {
          UI.elements.pages.setAttribute("data-active", "false");
        }, 2000);
      };

      // Handle on click of create thumbnail
      attachHandler(UI.elements.thumbnail, function(event) {
        // Update the thumbnail and update the UI
        Page.updateThumbnail();
        teasePages();
      });

      // Handle on click of add image layer
      attachHandler(UI.elements.add, function(event) {
        Page.addPage();
        teasePages();
      });

      // Handle on click of add text layer
      attachHandler(UI.elements.text, function(event) {
        var layerIndex = Comic.currentPage().layerIndex;
        var index = layerIndex === 0 ? null : layerIndex + 1;
        var layer = Page.addLayer(null, index, {
          type: Layer.Types.TEXT,
        });
        var text = new TextElement({
          layer: layer,
          debug: config.debug,
        });
        TextController.initialize(text, true);
      });

      // Handle on click of logout button
      attachHandler(UI.elements.logout, UI.logout);

    },

    // Method to log the user out after confirmation
    logout: function(confirm) {

      confirm = confirm === false ? confirm : true;

      // HACK: Move strings to config
      var message = [
        "Are you sure you would like to log out? ",
        "Any unsaved changes will be lost.",
      ].join("\n");

      if (confirm && !window.confirm(message)) {
        return;
      }

      API.users.logout({}, function(success, response) {
        Events.global.emit("tcm.route", "/gallery");
        window.location.reload();
      });

    },

  };

  // Wait for the comic to initialize before initializing the UI manager
  Events.global.on("tcm.initialized", UI.initialize);

  // Public / exposed object
  return UI;

})();
